var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78,177.2L78,177.2c-15.4,0-28,12.5-28,28v120c0,15.4,12.5,28,28,28c15.4,0,28-12.5,28-28v-120 C105.9,189.7,93.4,177.2,78,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.1,41.5H236c-62.6,6-111.3,51.8-112.1,107.6h252.2C375.3,93.3,326.6,47.5,264.1,41.5z M212.4,99.1 c0,7.8-6.4,14.1-14.4,14.2c-8,0-14.5-6.3-14.5-14.1v-0.1c0-7.8,6.4-14.1,14.4-14.2C205.9,84.9,212.4,91.2,212.4,99.1L212.4,99.1z  M320.4,99.1c0,7.8-6.4,14.1-14.4,14.2c-8,0-14.5-6.3-14.5-14.1v-0.1c0-7.8,6.4-14.1,14.4-14.2C313.9,84.9,320.4,91.2,320.4,99.1 L320.4,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422,177.2L422,177.2c-15.4,0-28,12.5-28,28v120c0,15.4,12.5,28,28,28c15.4,0,28-12.5,28-28v-120 C450,189.7,437.5,177.2,422,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377,161H123.1l0,0c-0.1,1.1-0.2,2.1-0.2,3.2V346c0,19.5,15.5,35.3,34.7,35.3h1.4v71.9c0,15.4,12.5,28,28,28 c15.4,0,28-12.5,28-28v-71.9h70.2v71.9c0,15.4,12.5,28,28,28c15.4,0,28-12.5,28-28v-71.9h1.4c19.2,0,34.7-15.7,34.7-35.3V164.2 C377.1,163.2,377.1,162.1,377,161z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.1,65.6l-21.8-38.7c0,0-9.8-13.8-24.5-5.4c-12.7,7.4-5.7,22-5.7,22l27.1,45.8L170.1,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.2,65.8l23.2-40c0,0,10.1-12.4,22.7-3.7s5,21.8,5,21.8l-26.3,45.4L330.2,65.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid2);
export default __webpack_public_path__ + "static/media/android2.fe594b7da8c77179eb3b4c81f31f84dc.svg";
export { ForwardRef as ReactComponent };